import React from 'react';
import { Label } from "@/components/ui/label";
import { AlertCircle } from 'lucide-react';

const FormField = ({ id, label, children, error, required = true, description }) => (
    <div className="space-y-1">
        <Label htmlFor={id} className={error ? 'text-destructive' : ''}>{label}{required ? ' *' : ''}</Label>
        {children}
        {description && <p className="text-xs text-muted-foreground pt-1">{description}</p>}
        {error && <p className="text-xs text-destructive flex items-center pt-1"><AlertCircle className="h-3 w-3 mr-1" />{error}</p>}
    </div>
);

export default FormField;